import { createSlice } from "@reduxjs/toolkit";
const initialState = { coachmark: 1 };
const StepSlice = createSlice({
  name: "Step",
  initialState,
  reducers: {
    nextStep(state, action) {
      // console.log(state.coachmark+action.payload)
      if(state.coachmark+action.payload == 11){
        return {
          ...state,
          coachmark: 0,
        };
      }else{
        return {
          ...state,
          coachmark: state.coachmark + action.payload,
        };
      }
    },
    backStep(state, action) {
      console.log(state.coachmark-action.payload)

      return {
        ...state,
        coachmark: state.coachmark - action.payload,
      };
    },
  },
});
export const { nextStep, backStep } = StepSlice.actions;
export default StepSlice.reducer;
